import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const expensesRoutes = [
	{
		key: "expenses-summary",
		exact: true,
		path: `${APP_PREFIX_PATH}/expenses/views`,
		component: React.lazy(() => import("views/app-views/expenses/pages/ExpenseViews")),
	},
];
